import { promiseState } from "../../helper"
import { churchRecord } from "../actions/types"

const { pendingState, fulfilledState, rejectedState } = promiseState

const initialState = {
	isLoading: false,
	message: null,
	errors: [],
	data: [],
	page: {
		totalPage: 0,
		currentPage: 1,
		totalData: 0,
	},
	detail: {},
}

const churchRecordReducer = (state = initialState, action) => {
	switch (action.type) {
		case pendingState(churchRecord.GET_RECORD): {
			return Object.assign({}, state, {
				isLoading: true,
			})
		}

		case rejectedState(churchRecord.GET_RECORD): {
			return Object.assign({}, state, {
				isLoading: false,
			})
		}

		case fulfilledState(churchRecord.GET_RECORD): {
			return Object.assign({}, state, {
				isLoading: false,
				data: action.payload.data.data,
				page: {
					totalPage: action.payload.data.page.totalPage,
					currentPage: action.payload.data.page.currentPage,
					totalData: action.payload.data.page.totalData,
				},
			})
		}

		case pendingState(churchRecord.GET_RECORD_DETAIL): {
			return Object.assign({}, state, {
				isLoading: true,
			})
		}

		case rejectedState(churchRecord.GET_RECORD_DETAIL): {
			return Object.assign({}, state, {
				isLoading: false,
			})
		}

		case fulfilledState(churchRecord.GET_RECORD_DETAIL): {
			return Object.assign({}, state, {
				isLoading: false,
				detail: action.payload.data.data,
			})
		}

		default:
			return state
	}
}

export default churchRecordReducer
